exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".itb-custom-btn[data-v-089fd39e]{background:#1976d2;border-radius:4px;padding:4px 8px;border:none;cursor:pointer;font-weight:700;margin-right:4px}.itb-custom-btn[data-v-089fd39e],.itb-custom-btn i[data-v-089fd39e]{color:#fff!important}.itb-custom-btn[data-v-089fd39e]:hover{background:#1565c0}.itb-btn-delete[data-v-089fd39e]{color:#f44336!important;cursor:pointer}.itb-btn-delete[data-v-089fd39e]:hover{color:#ae0f03!important}", ""]);

// exports
